import React, {useState} from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from "react-router-dom";
import Confirmation from "components/Confirmation";
import {
  TableRow,
  TableCell,
  makeStyles,
  Typography,
  Button,
  Table,
  TableHead,
  TableBody,
} from "@material-ui/core";
import { ROOT, ADD_EDIT_PUNCH_SUPERVISOR, SUPERVISOR_PTO } from "navigation/CONSTANTS";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { STATUS_IN, STATUS_OUT, STATUS_TRANSFER } from "config/CONSTANTS";
import { Edit, Delete } from "@material-ui/icons";
import { timeConfig } from "config";
import { dateConfig } from "config";
import ConfirmDialog from "components/ConfirmDialog";
import { getDurationInHours,properCase } from "utils";
import { PTO } from "config";

const useStyles = makeStyles(() => ({
  punchDetailsTable: {
    border: "1px solid #e0e0e0",
  },
}));

const DayRecords = (props) => {
  const { row } = props;
  const classes = useStyles();
  const {editable} = row;
  let color = "disabled";
  let errorColor = "disabled";
  if(editable) {
    errorColor="error";
    color="primary";
  }
  const { t } = useTranslation();
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: "pgPunch.tlConfirmation", subTitle: "pgReview.msgDeletePunch" });
  const [confirmationBox, setConfirmationBox] = useState({ isOpen: false, title: t("pgPunch.tlConfirmation"), subTitle: t("pgReview.msgDeleteSuccess")});

  const onDelete = (punchRow) => {
    
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    
    props.deleteHandler(punchRow);
  };

  return (
    <React.Fragment>
      <Table
        size="small"
        aria-label="punches"
        className={classes.punchDetailsTable}
      >
        <TableHead>
          <TableRow>
            <TableCell>{properCase(t("pgReview.tableHeads.jobFamily"))}</TableCell>
            <TableCell>{properCase(t("pgReview.tableHeads.in"))}</TableCell>
            <TableCell>{properCase(t("pgReview.tableHeads.out"))}</TableCell>
            <TableCell>{properCase(t("pgReview.tableHeads.duration"))}</TableCell>
            <TableCell>{properCase(t("pgReview.tableHeads.details"))}</TableCell>
            <TableCell align="right">
              {properCase(t("pgReview.tableHeads.action"))}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {row.punches.map((punchRow, ind) => {
            console.log("Index:" + ind + ": punchRow: ", punchRow);
            const ts = (time) =>
              time ? (
                <span>
                  {moment(time).format(timeConfig.format3)}
                  <br />
                  {moment(time).format(dateConfig.format3)}
                </span>
              ) : null;

            return (
              <TableRow key={punchRow.id}>
                <TableCell component="th" scope="row">
                  {punchRow.jobName}
                </TableCell>
                <TableCell>
                  {ts(punchRow.inLocalTS)}
                </TableCell>
                <TableCell>
                  {ts(punchRow.outLocalTS)}
                </TableCell>
                <TableCell>
                  {getDurationInHours(punchRow)}
                </TableCell>
                <TableCell>
                  {punchRow.activityGroup} {punchRow.districtId}{" "}
                  {punchRow.buildingId}{" "}
                </TableCell>
                <TableCell align="right" >
                  {true && (
                    <>
                      <Link
                        title={t("pgReview.tableStaticText.btnEdit")}
                        to={{
                          pathname: !editable?'':(PTO === punchRow.jobName) ? SUPERVISOR_PTO : ADD_EDIT_PUNCH_SUPERVISOR,
                          state: {
                            punch: punchRow,
                            worker: props.worker,
                          },
                        }}
                      >
                        <Edit  color= {color} />
                      </Link>
                      <Link title={t("pgReview.tableStaticText.btnDelete")}>
                        <Delete
                          color={errorColor}
                          onClick={() =>
                            setConfirmDialog({
                              ...confirmDialog,
                              isOpen: !editable?false:true,
                              onConfirm: () => {
                                onDelete(punchRow);
                              },
                            })
                          }
                        />
                      </Link>
                    </>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <ConfirmDialog 
      confirmDialog = {confirmDialog}
      setConfirmDialog = {setConfirmDialog}/>
    </React.Fragment>
  );
};

DayRecords.propTypes = {
  worker: PropTypes.object,
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    hours: PropTypes.string.isRequired,
    day: PropTypes.string.isRequired,
    isApproved: PropTypes.bool,
    editable:PropTypes.bool,
    punches: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        jobName: PropTypes.string.isRequired,
        activityName: PropTypes.string.isRequired,
        activityTS: PropTypes.string,
        inLocalTS: PropTypes.string,
        activityGroup: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default DayRecords;
  